import React from "react";
import { Alert, Button, Card, Grid, Space, Tag, theme, Typography } from "antd";
import { TrophyOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import RulesSection from "./beerpong/RulesSection";
import { useBeerpongRules } from "./beerpong/hooks/useBeerpongRules";
import { DATE_TIME_FORMAT } from "../drinks/drinkStats/constants";
import { useOnlineStatus } from "@dowty/offline";
import { PageHeader } from "@dowty/ui";
import { useTranslation } from "react-i18next";
import "./beerpong/beerpong.css";

const { Title, Paragraph, Text } = Typography;
const { useBreakpoint } = Grid;

const Beerpong: React.FC = () => {
    const navigate = useNavigate();
    const screens = useBreakpoint();
    const { token } = theme.useToken();

    const {
        origins,
        checkedOrigins,
        groupedRules,
        hasActiveFilter,
        toggleOrigin,
        isFromCache,
        fetchedAt,
    } = useBeerpongRules();
    const isOnline = useOnlineStatus();
    const { t } = useTranslation();

    return (
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
            <PageHeader title={t("games.names.beerpong")} subtitle={t("games.details.beerpong.description")} />
            {!isOnline && (
                <Alert
                    type="warning"
                    showIcon
                    message={t("games.details.beerpong.rules.offlineTitle")}
                    description={t("games.details.beerpong.rules.offlineDescription")}
                />
            )}
            {isFromCache && origins.length > 0 && (
                <Tag style={{ alignSelf: "flex-start" }}>
                    {t("games.details.beerpong.rules.savedTag", {
                        when: fetchedAt ? dayjs(fetchedAt).format(DATE_TIME_FORMAT) : "",
                    })}
                </Tag>
            )}
            <RulesSection
                origins={origins}
                checkedOrigins={checkedOrigins}
                groupedRules={groupedRules}
                hasActiveFilter={hasActiveFilter}
                onToggleOrigin={toggleOrigin}
                screens={screens}
                token={token}
            />

            <Card
                className="beerpong-tournament-promo"
                title={
                    <Space align="center" size={12}>
                        <TrophyOutlined style={{ color: token.colorPrimary, fontSize: 24 }} />
                        <Title level={2} style={{ margin: 0, color: token.colorPrimary }}>
                            {t("games.details.beerpong.tournamentTitle")}
                        </Title>
                    </Space>
                }
            >
                <Space direction="vertical" size="middle" style={{ width: "100%" }}>
                    <Paragraph>{t("games.details.beerpong.tournamentDescription")}</Paragraph>
                    <Text type="secondary">{t("games.details.beerpong.tournamentNote")}</Text>
                    <Button
                        type="primary"
                        size="large"
                        onClick={() => navigate("/beerpong/tournaments")}
                        style={{ alignSelf: screens.xs ? "stretch" : "flex-start" }}
                    >
                        {t("games.details.beerpong.tournamentButton")}
                    </Button>
                </Space>
            </Card>
        </Space>
    );
};

export default Beerpong;
